import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    IconArrowLeft,
    IconCalendarEventFilled,
    IconEdit,
    IconGenderAgender,
    IconGenderFemale, IconGenderMale
} from "@tabler/icons-react";
import {getEventById, getAthleteByIdAndEvent, updateEventAthlete} from "../../db";

const AthleteEdit = () => {
    const { id, athlete } = useParams(); // id = eventId, athlete = athleteId
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [eventData, setEventData] = useState(null);
    const [shootingData, setShootingData] = useState({ bib: "", eventNote: "" });
    const [athleteData, setAthleteData] = useState(null);

    useEffect(() => {
        const load = async () => {
            const foundEvent = await getEventById(Number(id));
            const foundAthlete = await getAthleteByIdAndEvent(Number(id), Number(athlete));

            if (foundEvent) setEventData(foundEvent);
            if (foundAthlete) {
                setAthleteData(foundAthlete);

                let shootinDataFound = {
                    bib: foundAthlete.eventInfo.bib,
                    eventNote: foundAthlete.eventInfo.eventNote
                };

                setShootingData(shootinDataFound)
            } else {
                navigate(`/events/${id}`, { state: { error: t("athleteEvent.notFound") }});
            }
        };

        load();
    }, [id, athlete]);

    const handleSave = async () => {
        if (!isValid()) return;

        try {
            if (athleteData.eventInfo.id) {
                await updateEventAthlete(athleteData.eventInfo.id, shootingData);
                navigate(`/events/${eventData.id}/athlete/${athleteData.id}`);
            }
        } catch (error) {
            console.error("Error saving event:", error);
        }
    };

    const isValid = () => {
        return true;
    };

    return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full">
                <div className="shrink-0 w-10">
                    <Link to={`/events/${eventData?.id || id}/athlete/${athleteData?.id || athlete}`}>
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("eventsDetail.backToDetail")}</span>
                    </Link>
                </div>
                <div className="grow flex items-center justify-center gap-2 shrink-0">
                    <IconEdit stroke={1.5} className="w-4 h-auto" />
                    <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">
                        {athleteData ? athleteData.nickname || `${athleteData.firstname} ${athleteData.lastname}` : '...'}
                    </h1>
                </div>
                <div className="shrink-0 w-10">
                </div>
            </div>
            {athleteData && (
                <div className="grow overflow-y-auto overflow-x-hidden">
                    <div className="flex flex-col gap-6 px-2">
                        <div className="pt-4 gap-4 grid sm:grid-cols-2 md:grid-cols-4">
                            <div className="flex flex-col gap-2">
                                <label htmlFor="athleteBib" className="font-bold">
                                    {t("athlete.bib")}
                                </label>
                                <div className="form-input-wrap">
                                    <input
                                        value={shootingData.bib}
                                        inputMode="numeric"
                                        type="number"
                                        onChange={(e) => setShootingData({ ...shootingData, bib: e.target.value })}
                                        id="athleteBib"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2 sm:col-span-2">
                                <label htmlFor="athleteNote" className="font-bold">
                                    {t("athlete.eventNote")}
                                </label>
                                <div className="form-input-wrap">
                                    <textarea
                                        onChange={(e) => setShootingData({ ...shootingData, eventNote: e.target.value })}
                                        id="athleteNote"
                                    >{shootingData.eventNote}</textarea>
                                </div>
                            </div>
                            {/*TODO ADD HERE MORE FIELDS*/}
                        </div>
                        <div className="">
                            <button onClick={handleSave} className="button-primary">{t("athletes.save")}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AthleteEdit;
